// The existing project snapshots contain gun totals, not physical charger IDs.
// Pair guns into illustrative dual-gun cabinets; never present these as surveyed assets.
export function stationDevices (row) {
  if (!row) return []
  const total = Math.max(0, Math.floor(Number(row.plugs) || 0))
  const fault = Math.min(total, Math.max(0, Math.floor(Number(row.chargeFault) || 0)))
  const charging = Math.min(total - fault, Math.max(0, Math.floor(Number(row.charging) || 0)))
  const guns = Array.from({ length: total }, (_, i) => ({
    id: `${row.id}-gun-${i + 1}`,
    number: String(i + 1).padStart(2, '0'),
    state: i >= total - fault ? 'fault' : (i * 17 % total) < charging ? 'charging' : 'idle'
  }))
  // Distribute active guns across the site, preserving exact snapshot totals
  // even when the modular permutation above isn't coprime with the total.
  const order = guns.filter(g => g.state !== 'fault').sort((a, b) => Number(a.number) % 3 - Number(b.number) % 3 || Number(a.number) - Number(b.number))
  order.forEach((g, i) => { g.state = i < charging ? 'charging' : 'idle' })
  return Array.from({ length: Math.ceil(total / 2) }, (_, i) => {
    const pair = guns.slice(i * 2, i * 2 + 2)
    return { id: `${row.id}-cabinet-${i + 1}`, number: `A-${String(i + 1).padStart(2, '0')}`, zone: i < Math.ceil(total / 4) ? 'A' : 'B', guns: pair, state: pair.some(g => g.state === 'fault') ? 'fault' : pair.some(g => g.state === 'charging') ? 'charging' : 'idle' }
  })
}

export const STATE_LABELS = { charging: '充电中', idle: '空闲', fault: '待排查' }

// Metres: rear equipment island, 5.1 m parking bay, and a clear central aisle.
export function stationLayout (devices) {
  const perBank = Math.ceil(devices.length / 2)
  return {
    length: Math.max(23, perBank * 3.55 + 2),
    bays: devices.map((device, i) => {
      const side = i < perBank ? -1 : 1
      return { id: device.id, side, z: (i % perBank - (perBank - 1) / 2) * 3.55, chargerX: side * 9.1, carX: side * 5.9 }
    })
  }
}

export function stationZones (devices) {
  return ['A', 'B'].map(id => {
    const guns = devices.filter(d => d.zone === id).flatMap(d => d.guns)
    const charging = guns.filter(g => g.state === 'charging').length
    const fault = guns.filter(g => g.state === 'fault').length
    return { id, total: guns.length, charging, fault, idle: guns.length - charging - fault, utilization: guns.length ? charging / guns.length * 100 : 0 }
  })
}
export function stationInsights (row, rows) {
  if (!row) return null
  const total = rows.reduce((a, r) => a + Number(r.plugs || 0), 0)
  const charging = rows.reduce((a, r) => a + Number(r.charging || 0), 0)
  const rate = row.plugs ? row.charging / row.plugs * 100 : 0
  const average = total ? charging / total * 100 : 0
  return { rate, average, difference: rate - average, incomePerGun: row.plugs ? row.chargeIncome / row.plugs : null, kwhPerGun: row.plugs ? row.chargeKwh / row.plugs : null, incomePerKwh: row.chargeKwh ? row.chargeIncome / row.chargeKwh : null, ranked: [...rows].sort((a, b) => (b.plugs ? b.charging / b.plugs : 0) - (a.plugs ? a.charging / a.plugs : 0)) }
}

export function constrainTarget (target, length) {
  target.x = Math.max(-10.2, Math.min(10.2, target.x))
  target.y = Math.max(0.5, Math.min(8, target.y))
  target.z = Math.max(-length / 2 - 1, Math.min(length / 2 + 1, target.z))
  return target
}
